import React from "react";
import { useNavigate } from "react-router-dom";
import "./CampusCss/Mayalawas-Campus.css"

const MayalwasGurukul = () => {

    const navigate = useNavigate();

    return (
    <div className="gurukul-containerMG">

  {/* Header Section */}
  <header className="headerMG">
    <div className="header-contentMG">
      <h1>📿 Shri Gurave Namah</h1>
      <h2>Brahmarishi Kheteshwar Ved Vigyan Gurukul, Mayalwas</h2>
      <div className="header-decorationMG"></div>
    </div>
  </header>

  {/* Introduction */}
  <section className="introMG">
    <div className="intro-contentMG">
      <div className="intro-textMG">
        <h2>Welcome to Our Sacred Gurukul</h2>
        <p>
          Brahmarishi Kheteshwar Ved Vigyan Gurukul is located in <strong>Mayalwas, Tehsil Siwana, District Barmer</strong>.  
          Established in <strong>2016</strong>, the Gurukul has educated <strong>800+ Rishikumars</strong>, and currently,  
          <strong>over 250 Rishikumars</strong> are pursuing their studies in this serene environment.
        </p>
      </div>
      <img src="/mayalawas.jpg" alt="Mayalwas Gurukul" className="main-imageMG" />
    </div>
  </section>

  {/* Guru's Blessing */}
  <section className="guru-blessingMG">
    <div className="section-headerMG">
      <div className="decoration-lineMG"></div>
      <h2>🌿 The Blessings of Sadgurudev</h2>
      <div className="decoration-lineMG"></div>
    </div>
    <div className="guru-contentMG">
      <img src="/MC.png" alt="Guru Blessing" className="section-imageMG" />
      <div className="guru-textMG">
        <p>
          With the divine blessings of <strong>Brahmakul Guru Shri Khetaram Ji Maharaj</strong> and <strong>Sadgurudev Shri Shri Tulcharam Ji Maharaj</strong>, 
          this Gurukul became a sacred institution for Rajpurohit children to learn <strong>Dharma (righteousness), Karma (duty), and character development</strong>.
        </p>
        <div className="quoteMG">
          "Education is the manifestation of perfection already in man" - Swami Vivekananda
        </div>
      </div>
    </div>
  </section>

  {/* Education & Facilities */}
  <section className="educationMG">
    <div className="section-headerMG">
      <h2>📖 Vedic and Modern Education</h2>
      <p className="section-subtitleMG">Blending ancient wisdom with contemporary knowledge</p>
    </div>
    <div className="edu-flexMG">
      <div className="edu-boxMG">
        <div className="edu-iconMG">🕉️</div>
        <h3>Vedic Education</h3>
        <p>In-depth teachings of the <strong>Vedas, Shastras, and Upanishads</strong> using traditional methods.</p>
      </div>
      <div className="edu-boxMG">
        <div className="edu-iconMG">💻</div>
        <h3>Smart Classes</h3>
        <p>Advanced <strong>digital classrooms</strong> making education more engaging and interactive.</p>
      </div>
      <div className="edu-boxMG">
        <div className="edu-iconMG">📚</div>
        <h3>Extensive Library</h3>
        <p>Fully air-conditioned library with <strong>Vedic, spiritual, and modern literature</strong>.</p>
      </div>
    </div>
  </section>

  {/* Gaushala Section */}
  <section className="gaushalaMG">
    <div className="section-headerMG">
      <h2>🐄 Gaushala & Organic Farming</h2>
      <p className="section-subtitleMG">Living in harmony with nature</p>
    </div>
    <div className="gaushala-contentMG">
      <div className="gaushala-textMG">
        <p>
          The Gurukul houses a <strong>Gaushala (cow shelter)</strong> with <strong>50-60 cows</strong>,  
          ensuring that students receive <strong>pure, chemical-free milk</strong>.  
          Additionally, <strong>organic farming</strong> is practiced to provide <strong>healthy, natural food</strong>.
        </p>
        <ul className="features-listMG">
          <li>🌱 Organic vegetable cultivation</li>
          <li>🥛 Daily fresh milk from indigenous breeds</li>
          <li>♻️ Sustainable farming practices</li>
        </ul>
      </div>
      <img src="/gaushala.png" alt="Gurukul Gaushala" className="section-imageMG" />
    </div>
  </section>

  {/* Sports Section */}
  <section className="sportsMG">
    <div className="section-headerMG">
      <h2>🏆 Sports & Physical Development</h2>
      <p className="section-subtitleMG">Healthy mind in a healthy body</p>
    </div>
    <div className="sports-contentMG">
      <img src="/SportMC.png" alt="Sports Activities" className="section-imageMG" />
      <div className="sports-textMG">
        <p>
          Sports play a vital role in <strong>physical and mental well-being</strong>.  
          Students engage in <strong>2 hours of daily sports activities</strong>, including  
          <strong>district-level volleyball and skating competitions</strong>, bringing glory to the Gurukul.
        </p>
        <div className="sports-highlightsMG">
          <div className="highlight-boxMG">
            <div>🏐</div>
            <span>Volleyball Team</span>
          </div>
          <div className="highlight-boxMG">
            <div>⛸️</div>
            <span>Skating Champions</span>
          </div>
          <div className="highlight-boxMG">
            <div>🏅</div>
            <span>Yoga Practice</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  {/* Statistics */}
  <section className="statsMG">
    <div className="section-headerMG">
      <h2>📊 Achievements of the Gurukul</h2>
      <p className="section-subtitleMG">Our milestones and accomplishments</p>
    </div>
    <div className="stats-gridMG">
      <div className="stat-boxMG">
        <div className="stat-numberMG">800+</div>
        <div className="stat-labelMG">Rishikumars educated (2016-2024)</div>
      </div>
      <div className="stat-boxMG">
        <div className="stat-numberMG">250+</div>
        <div className="stat-labelMG">Current students</div>
      </div>
      <div className="stat-boxMG">
        <div className="stat-numberMG">10+</div>
        <div className="stat-labelMG">State-level competitions</div>
      </div>
      <div className="stat-boxMG">
        <div className="stat-numberMG">100%</div>
        <div className="stat-labelMG">Value-based education</div>
      </div>
    </div>
  </section>


   {/* Photo Gallery */}
       <section className="gallery">
         <h2 className="gallery__title">Photo Gallery</h2>
         <div className="gallery__grid">
           <img src="/home2.jpg" alt="Gallery 1" className="gallery__image" />
           <img src="/home1.jpg" alt="Gallery 2" className="gallery__image" />
           <img src="/home3.jpg" alt="Gallery 3" className="gallery__image" />
           <img src="/mayalawas1.jpg" alt="Gallery 4" className="gallery__image" />
           <img src="/playing.jpg" alt="Gallery 5" className="gallery__image" />
         </div>
       </section>

</div>
    );
  };
  
  export default MayalwasGurukul;
  